export default "__VITE_ASSET__5f2798cc__"